export default __webpack_public_path__ + "static/media/3.3b65b48c.mp4";